import SupplierModifier from "../components/SupplierModifier";
import useModalForm from "../../../@hooks/useModalForm";
import SupplierModel from "../domainModel/supplier";
export default function useAddSupplier() {
  const { open } = useModalForm(SupplierModifier);
  const addSupplier = () => {
    return new Promise((resolve,reject)=>{
      open(
        (res) =>
          new SupplierModel(res).save().then((res)=>{
            resolve(res)
            return res
          }).catch((e) => {
            reject(e)
            throw e
          }),
        {},
        {
          title: "添加供应商",
          width: 1000,
        }
      );
    })
  };

  return {
    addSupplier,
  };
}
